import React from "react";

// A donut chart that displays multiple segments. Pure SVG, no library.
// segments: [{ value: number, color: string, label?: string }]
function RingChart({ segments = [], size = 140, thickness = 14, center, subCenter }) {
  const total = segments.reduce((s, x) => s + Math.max(0, x.value), 0) || 1;
  const radius = (size - thickness) / 2;
  const cx = size / 2;
  const cy = size / 2;
  const circumference = 2 * Math.PI * radius;

  let offset = 0;
  const arcs = segments.map((seg, i) => {
    const v = Math.max(0, seg.value);
    const frac = v / total;
    const len = circumference * frac;
    const arc = (
      <circle
        key={i}
        cx={cx}
        cy={cy}
        r={radius}
        fill="none"
        stroke={seg.color}
        strokeWidth={thickness}
        strokeDasharray={`${len} ${circumference - len}`}
        strokeDashoffset={-offset}
        strokeLinecap="round"
        style={{ filter: `drop-shadow(0 0 4px ${seg.color})` }}
      />
    );
    offset += len;
    return arc;
  });

  return (
    <div style={{ position: "relative", width: size, height: size, display: "inline-block" }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ transform: "rotate(-90deg)" }}>
        <circle cx={cx} cy={cy} r={radius} fill="none" stroke="rgba(139, 155, 209, 0.1)" strokeWidth={thickness} />
        {arcs}
      </svg>
      {(center || subCenter) && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none",
          }}
        >
          {center && (
            <div
              style={{
                fontFamily: "var(--font-display)",
                fontSize: 22,
                fontWeight: 700,
                color: "var(--text-primary)",
                lineHeight: 1,
              }}
            >
              {center}
            </div>
          )}
          {subCenter && (
            <div style={{ fontSize: 10, color: "var(--text-muted)", marginTop: 4, textTransform: "uppercase", letterSpacing: "0.05em" }}>
              {subCenter}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default RingChart;
